const removeSpecialChars = (str = '', except = '', removeToo = '') => {
  return str.replace(new RegExp(`[^\\w\\s${except}]|[${removeToo}]`, 'gi'), '')
}

export default removeSpecialChars
